import { render, staticRenderFns } from "./studentSingleSelectDialog.vue?vue&type=template&id=58b7f9b4&scoped=true&"
import script from "./studentSingleSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./studentSingleSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./studentSingleSelectDialog.vue?vue&type=style&index=0&id=58b7f9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7f9b4",
  null
  
)

export default component.exports